const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.student || !attrs.student.perfilAlumnoId) {
    errors.usuario = 'Debe seleccionar el alumno';
  }

  return errors;
};

export default validate;
